
<script>
import { Pie } from 'vue-chartjs';
import { mapGetters, mapActions } from "vuex";
import { EventBus } from '../../libs/event-bus.js';


export default {
   extends: Pie,
   data() {
      return {
         datacollection: {
            //Data to be represented on x-axis
           datasets: [{
					data: [
						0, 0
					],
					backgroundColor: [ '#f2e5c9', '#daefc9' ],
					label: 'Dataset 1'
				}],
				labels: [
					'Pending',
					'Solved'
				]
         },
         //Chart.js options that controls the appearance of the chart
         options: {
                    maintainAspectRatio: false,
                }
      }
   },
     computed: {
    ...mapGetters("statistics", ["statistics"]),
  },
  methods:{
      render(){
       this.datacollection.datasets[0].data[1] = this.statistics.solved
       this.datacollection.datasets[0].data[0] = this.statistics.pending
       this.renderChart(this.datacollection, this.options)
      }
  },
   mounted() {
       EventBus.$on('i-got-clicked', clickCount => {
        console.log(`Oh, that's nice. It's gotten ${clickCount} clicks! :)`)
        this.datacollection.datasets[0].data[1] = this.statistics.solved
       this.datacollection.datasets[0].data[0] = this.statistics.pending
       this.renderChart(this.datacollection, this.options)
        });

      //renderChart function renders the chart with the datacollection and options object.
       this.datacollection.datasets[0].data[1] = this.statistics.solved
       this.datacollection.datasets[0].data[0] = this.statistics.pending
       this.renderChart(this.datacollection, this.options)
   }
}

</script>




// WEBPACK FOOTER //
// src/components/dashboard/PieChart.vue